// extracted by mini-css-extract-plugin
export default {"large":"only screen and (min-width: 992px)","link":"a8Jx9 _2aJ8N _1R_Wx"};